import { useEffect, useState } from 'react'
import axios from 'axios'

const PeticionTraeDatos = (Url) => {

    const [data, setData] = useState([])

    const peticionTraeDatosAll = async () => {
        try {
            const response = await axios.get(Url)
            setData(response.data)
        } catch (error) {
            setData([])
            console.log(error)
        }
    }


    useEffect(() => {
        peticionTraeDatosAll()
    }, [Url])
    return [data, setData]
}

export default PeticionTraeDatos